module.exports = __webpack_public_path__ + "img/KWD.34bc2795.svg";